
import React from 'react';
import { Wallet } from 'lucide-react';

interface EnhancedAccountBalanceProps {
  balance: number;
  size?: 'sm' | 'md' | 'lg';
}

export const EnhancedAccountBalance = ({ balance, size = 'md' }: EnhancedAccountBalanceProps) => {
  const sizeClasses = {
    sm: {
      container: 'py-2 px-3 rounded-lg',
      icon: 'h-3 w-3',
      label: 'text-xs',
      value: 'text-sm'
    },
    md: {
      container: 'py-2.5 px-4 rounded-xl',
      icon: 'h-4 w-4',
      label: 'text-xs',
      value: 'text-lg'
    },
    lg: {
      container: 'py-3 px-5 rounded-xl',
      icon: 'h-5 w-5',
      label: 'text-sm',
      value: 'text-xl'
    }
  };

  const classes = sizeClasses[size];

  return (
    <div className={`bg-gradient-to-r from-primary/5 to-primary/10 border border-primary/20 shadow-sm ${classes.container}`}>
      <div className="flex items-center gap-2">
        <Wallet className={`${classes.icon} text-primary`} />
        <div className="flex flex-col">
          <div className={`${classes.label} text-muted-foreground font-medium`}>Balance</div>
          <div className={`${classes.value} font-bold text-foreground`}>
            ${balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>
      </div>
    </div>
  );
};
